module.exports = __webpack_public_path__ + "img/software2.a2132554.jpg";